import React from 'react';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectors } from '@yola/subscription-manager-js';
import routersMap from 'src/js/router/helpers/routes-map';
import segment from 'src/js/modules/analytics/segment';
import NavbarHeader from 'src/js/common/components/navbar-header';

const {
  constants: { triggerIds, events },
  track,
} = segment;

function UpgradeContainer() {
  const navigate = useNavigate();
  const upgradeExists = useSelector(selectors.getHostingUpgradeAvailability);

  if (!upgradeExists) return null;

  const onUpgradeClick = () => {
    track(events.UPGRADE_TRIGGER_CLICKED, { triggerId: triggerIds.MYYOLA_HEADER });
    navigate(
      routersMap.paywall.url({
        query: {
          triggerId: 'header',
          paymentBackUrl: window.location.href,
          actionId: triggerIds.MYYOLA_HEADER,
        },
      })
    );
  };

  return (
    <React.Fragment>
      <NavbarHeader.Divider />
      <NavbarHeader.UpgradeButton onClick={onUpgradeClick} label={i18next.t('Upgrade')} />
    </React.Fragment>
  );
}

export default UpgradeContainer;
